const BASE_DATA_SOURCES = [
  {
    type: 'piano',
    spaces: [],
    apiKey: '',
    guideline: '',
  },
  {
    type: 'capsule',
    apiKey: '',
    indexName: '',
    guideline: '',
  },
  {
    type: 'qlik',
    apiKey: '',
    guideline: '',
  },
  {
    type: 'googleAnalytics',
    propertyId: '',
    guideline: '',
  },
  {
    type: 'mailchimp',
    apiKey: '',
    guideline: '',
  },
  {
    type: 'parsely',
    apiKey: '',
    apiSecret: '',
    guideline: '',
  },
];

const hasNonEmptyValue = value =>
  typeof value === 'string' ? value.trim() !== '' : Boolean(value);

export const createEmptyDataSources = () =>
  BASE_DATA_SOURCES.map(dataSource => ({
    ...dataSource,
    ...(Array.isArray(dataSource.spaces) ? { spaces: [] } : {}),
  }));

export const findDataSourceByType = (dataSources = [], type) =>
  dataSources.find(dataSource => dataSource?.type === type) || null;

export const filterFilledDataSources = dataSources =>
  Array.isArray(dataSources)
    ? dataSources.filter(dataSource => {
        if (!dataSource) return false;

        if (dataSource.type === 'googleAnalytics') {
          return hasNonEmptyValue(dataSource.propertyId) && hasNonEmptyValue(dataSource.guideline);
        }

        if (dataSource.type === 'parsely') {
          return (
            hasNonEmptyValue(dataSource.apiKey) &&
            hasNonEmptyValue(dataSource.apiSecret) &&
            hasNonEmptyValue(dataSource.guideline)
          );
        }

        return hasNonEmptyValue(dataSource.apiKey) && hasNonEmptyValue(dataSource.guideline);
      })
    : [];

export const DATA_SOURCE_TYPES = BASE_DATA_SOURCES.map(dataSource => dataSource.type);

export default BASE_DATA_SOURCES;
